import React, { useEffect, useState } from 'react';
import SiteContent from '../components/site-items/SiteContent/SiteContent';
import Navbar from '../parts/Navbar/Navbar';
import Footer from '../parts/Footer/Footer';
import PageWrapper from '../components/page-items/PageWrapper/PageWrapper';
import Logo from '../components/logos/Logo/Logo';
import PageHeader from '../components/page-items/PageHeader/PageHeader';
import PageContent from '../components/page-items/PageContent/PageContent';
import NewsTitle from '../sections/News/NewsTitle/NewsTitle';
import {
    NewsDateContent,
    NewsTextContent,
} from '../sections/News/NewsText/NewsText';
import {
    NewsDetailsContainer,
    NewsGalleryContainer,
    NewsLoadingContainer,
    NewsTextContainer,
} from '../sections/News/NewsDetailsContainers/NewsDetailsContainers';
import { formatDate, scrollToTop } from '../helpers/helpersFunctions';
import PhotoGallery from '../sections/News/PhotoGallery/PhotoGallery';
import { fetchDetails } from '../helpers/fetchData';
import Menu from '../components/buttons/Menu/Menu';
import NewsQuote from '../sections/News/NewsQuote/NewsQuote';
import SectionButton from '../components/section-items/SectionButton/SectionButton';
import SectionContainer from '../components/section-items/SectionContainer/SectionContainer';
import LoadingSpinner from '../components/spinners/LoadingSpinner';

const NewsDetails = () => {
    const [news, setNews] = useState({});
    const [error, setError] = useState(false);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchDetails('posts', window.location.pathname.replace('/news/', ''))
            .then((res) => {
                if (res.statusCode === 404 || res.statusCode === 400) {
                    setError(true);
                } else {
                    setNews(res);
                }
            })
            .catch(() => setError(true))
            .finally(() => setIsFetching(false));

        scrollToTop();
    }, []);

    return (
        <SiteContent>
            <Navbar />
            <PageWrapper
                style={{
                    background:
                        'linear-gradient(to left bottom, #F7FAF2, 90%, #fdeaa7)',
                }}
            >
                <PageContent>
                    <PageHeader header={'News'} />
                    {isFetching ? (
                        <NewsLoadingContainer>
                            <LoadingSpinner />
                        </NewsLoadingContainer>
                    ) : (
                        <NewsDetailsContainer>
                            <NewsTextContainer>
                                {!error ? (
                                    <>
                                        <NewsTitle>{news.title}</NewsTitle>
                                        <NewsDateContent>
                                            {'Ostatnia aktualizacja: ' +
                                                formatDate(news.date)}
                                        </NewsDateContent>
                                        <NewsTextContent>
                                            {decodeURI(news.text)}
                                        </NewsTextContent>
                                        <NewsQuote>
                                            {
                                                'Obserwuj nasz fanpage na Facebooku by być zawsze na bieżąco,\ntam zawsze pojawiają się informacje o najnowszych relacjach!'
                                            }
                                        </NewsQuote>
                                    </>
                                ) : (
                                    <>
                                        <NewsTitle>
                                            {'Podany artykuł nie istnieje'}
                                        </NewsTitle>
                                        <NewsTextContent>
                                            {
                                                'Artykuł, który odwiedziłeś nie istnieje bądź został usunięty przed administrację.'
                                            }
                                        </NewsTextContent>
                                    </>
                                )}
                                <SectionContainer style={{ margin: 0 }}>
                                    <SectionButton
                                        text={'POWRÓĆ DO SEKCJI AKTUALNOŚCI'}
                                        section={'news'}
                                        color={'black'}
                                        backgroundColor={'transparent'}
                                        style={{ margin: 25, marginTop: 30 }}
                                    />
                                </SectionContainer>
                            </NewsTextContainer>
                            <NewsGalleryContainer>
                                <PhotoGallery
                                    images={news.images}
                                    title={news.title}
                                />
                            </NewsGalleryContainer>
                        </NewsDetailsContainer>
                    )}
                </PageContent>
                <Logo
                    width={600}
                    height={600}
                    style={{
                        position: 'absolute',
                        right: -160,
                        bottom: -140,
                        opacity: 0.07,
                        transform: 'rotate(12deg)',
                    }}
                />
            </PageWrapper>
            <Menu />
            <Footer />
        </SiteContent>
    );
};

export default NewsDetails;
